enum ThreatDefenceContentTypes {
  Campaign = "Campaign",
}
export default ThreatDefenceContentTypes;
